export default __webpack_public_path__ + "static/media/2450.557bc195.png";